<template>
  <div class="page">
    <div class="pointes-list">
      <div class="page__title">
        {{ getModuleConfig("expiring_page.form_title") }}
      </div>
      <div
        class="page__desc"
        v-html="getModuleConfig('expiring_page.form_desc')"
        v-if="getModuleConfig('expiring_page.form_desc')"
      ></div>
      <div class="page__content" v-if="getModuleConfig('expiring_page.content')" v-html="getModuleConfig('expiring_page.content')"></div>
      <ExpiringPointLogs :event-code="eventCode"></ExpiringPointLogs>
    </div>
  </div>
</template>

<script>
import pointMixin from "@/mixins/liff/point";
import ExpiringPointLogs from "@/components/Page/Liff/Point/ExpiringPointLogs";

export default {
  mixins: [pointMixin],
  components: {
    ExpiringPointLogs,
  },
  data() {
    return {
      eventCode: this.$route.query.event ?? null,
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/shared/components/_fields.scss';

.page {
  background: var(--liff-content_bg_color);
  min-height: 100vh;

  &__title {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
  }
  &__desc {
    font-size: 14px;
    line-height: 22px;
    color: var(--liff-secondary_text_color);
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
    b {
      color: var(--s-primary);
      font-weight: 600;
    }
  }
  &__content {
    margin: 10px 20px;
  }
}

.navigation {
  display: flex;
  align-items: center;
  padding: 16px 12px;
  background: var(--s-white);
  border-bottom: 1px solid #e5e5ea;

  &__back {
    background: none;
    border: none;
    padding: 0;
    margin-right: 12px;
    cursor: pointer;
    color: var(--s-primary);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
  }
}


</style>
